import type { Component, Entity2D } from '../../../odie';
import { CountBlockOptionDef } from '../../defs/block';

import { SharpenerBlockView } from './SharpenerBlockView';
import { SharpenerBlockProps } from './SharpenerBlock';

export type SharpenerBlockComponentOptions = {
  props: SharpenerBlockProps;
  option?: number;
};

export class SharpenerBlockComponent implements Component {
  public static readonly NAME = 'blockSharpener';

  public entity!: Entity2D;
  public view!: SharpenerBlockView;
  private props!: SharpenerBlockProps;
  private vertical = false;

  public init(args: SharpenerBlockComponentOptions): void {
    // get option def
    const optionDef = args.props.options?.[
      args.option || 0
    ] as CountBlockOptionDef;

    this.props = args.props;
    this.vertical =
      args.props.orientation === 'topToBottom' ||
      args.props.orientation === 'bottomToTop';
    this.view = new SharpenerBlockView(args.props);
    this.count = optionDef.count;
    this.entity.c.block.getGameplayState = () => this.getGameplayState();
    this.view.updateView(false);
  }

  public getGameplayState(): number {
    const options = this.props.options as CountBlockOptionDef[];
    return options.findIndex((opt) => {
      return opt.count === this.view.count;
    });
  }

  public get count(): number {
    return this.view.count;
  }

  public set count(value: number) {
    this.view.count = value;
    if (this.vertical) {
      this.entity.c.block.height = value + 1;
    } else {
      this.entity.c.block.width = value + 1;
    }
  }
}
